import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui';

interface DecorationMethodConflictModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Modal shown when user tries to combine print and embroidery products.
 */
export function DecorationMethodConflictModal({
  isOpen,
  onClose,
}: DecorationMethodConflictModalProps) {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="decoration-conflict-title"
        aria-describedby="decoration-conflict-description"
        className="relative w-full max-w-md bg-paper-2 rounded-section ring-1 ring-line overflow-hidden"
      >
        <div className="px-6 py-5">
          <h3
            id="decoration-conflict-title"
            className="text-lg font-semibold text-ink"
          >
            {t('creator.modals.methodConflictTitle')}
          </h3>
          <p
            id="decoration-conflict-description"
            className="text-sm text-ink-2 mt-2 leading-relaxed"
          >
            {t('creator.modals.methodConflictBody')}
          </p>
        </div>
        <div className="px-6 py-4 border-t border-line bg-paper flex justify-end">
          <Button variant="primary" onClick={onClose}>
            {t('creator.modals.understood')}
          </Button>
        </div>
      </div>
    </div>
  );
}
